import {FmlxTooltip} from 'fmlx-common-ui';

function DeepWellLabel() {
  return (
    <FmlxTooltip title="Deep Well" placement="top">
      <div
        style={{
          width: 'fit-content',
          padding: '2px 5px',
          borderRadius: 2,
          background: '#5589E0',
          color: '#fff',
        }}
      >
        DW
      </div>
    </FmlxTooltip>
  );
}

export default DeepWellLabel;
